// AddOfferModal.js
import { useState, useEffect } from 'react'
import './AddOfferModal.css'
import { BACKEND_URL } from '../../../services/Helper';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const notifyB = (msg) => toast.success(msg);
const notifyA = (msg) => toast.error(msg);

const AddOfferModal = ({ onClose, onOfferAdded, onOfferUpdated, editingOffer }) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        title: '',
        percentage: '',
        validTill: '',
        endTime: '',
        description: '',
        percentageWithFeedback: '',
        couponExpiryHours: 24,
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (editingOffer) {
            setFormData({
                title: editingOffer.title || '',
                percentage: editingOffer.percentage || '',
                validTill: editingOffer.validTill?.split("T")[0] || '',
                endTime: editingOffer.endTime || '',
                description: editingOffer.description || '',
                percentageWithFeedback: editingOffer.percentageWithFeedback || '',
                couponExpiryHours: editingOffer.couponExpiryHours || 24,
            });
        } else {
            setFormData({
                title: '',
                percentage: '',
                validTill: '',
                endTime: '',
                description: '',
                percentageWithFeedback: '',
                couponExpiryHours: 24,
            });
        }
    }, [editingOffer]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const token = localStorage.getItem('shoplogintoken');
            if (!token) {
                notifyA("You must be logged in");
                navigate('/shoplogin');
                return;
            }

            let url = `${BACKEND_URL}/nearbe/createoffer`;
            let method = "POST";

            if (editingOffer) {
                url = `${BACKEND_URL}/nearbe/updateoffer/${editingOffer._id}`;
                method = "PUT";
            }

            const res = await fetch(url, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify(formData),
            });

            const data = await res.json();
            if (res.ok) {
                if (editingOffer) {
                    notifyB("Offer Updated Successfully!");
                    if (onOfferUpdated) onOfferUpdated(data.updatedOffer || data.offer);
                } else {
                    notifyB("Offer Created Successfully!");
                    if (onOfferAdded) onOfferAdded(data.offer); // 👈 always use populated offer
                }
                onClose();
            } else {
                notifyA(data.error || "Failed");
            }
        } catch (error) {
            console.error("Error:", error);
            notifyA("Something went wrong!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="offermodal-container">
                <h2>{editingOffer ? "Edit Offer" : "Create New General Offer"}</h2>
                <form onSubmit={handleSubmit}>
                    <div className="offerform-row">
                        <div className="offerform-group">
                            <label htmlFor="title">Offer Title</label>
                            <input
                                type="text"
                                id="title"
                                name="title"
                                placeholder="Enter offer title"
                                value={formData.title}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="offerform-group">
                            <label htmlFor="percentage">Offer Percentage (%)</label>
                            <input
                                type="number"
                                id="percentage"
                                name="percentage"
                                placeholder="Enter percentage"
                                value={formData.percentage}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="offerform-row">
                        <div className="offerform-group">
                            <label htmlFor="validTill">Valid Till</label>
                            <input
                                type="date"
                                id="validTill"
                                name="validTill"
                                value={formData.validTill}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="offerform-group">
                            <label htmlFor="endTime">End Time</label>
                            <input
                                type="time"
                                id="endTime"
                                name="endTime"
                                value={formData.endTime}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="offerform-row">
                        <div className="offerform-group full-width">
                            <label htmlFor="description">Offer Description</label>
                            <textarea
                                id="description"
                                name="description"
                                placeholder="Enter offer description"
                                value={formData.description}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="offerform-row">
                        <div className="offerform-group">
                            <label htmlFor="percentageWithFeedback">
                                Bonus % with Feedback <span style={{fontWeight:'400',opacity:0.6}}>(optional — higher discount after user writes review)</span>
                            </label>
                            <input
                                type="number"
                                id="percentageWithFeedback"
                                name="percentageWithFeedback"
                                placeholder="e.g. 25 (leave blank to disable)"
                                value={formData.percentageWithFeedback}
                                onChange={handleChange}
                                min="1"
                                max="100"
                            />
                        </div>
                        <div className="offerform-group">
                            <label htmlFor="couponExpiryHours">Coupon Valid For (hours)</label>
                            <input
                                type="number"
                                id="couponExpiryHours"
                                name="couponExpiryHours"
                                placeholder="Default: 24"
                                value={formData.couponExpiryHours}
                                onChange={handleChange}
                                min="1"
                            />
                        </div>
                    </div>

                    <div className="modal-actions">
                        <button type="submit" className="offersubmit-btn" disabled={loading}>
                            {loading
                                ? (editingOffer ? "Updating..." : "Creating...")
                                : (editingOffer ? "Update Offer" : "Create Offer")}
                        </button>
                        <button type="button" className="offercancel-btn" onClick={onClose}>Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default AddOfferModal;
